import React from 'react'
import { Card, Button, Col } from 'react-bootstrap'
import { getClassificationFeatures, hasClassificationFeatures, getRandomFeatures } from 'utils/classification'
import { onUpgradePlan } from 'utils/general'
import { showUpgradeCardModal } from 'actions'

import { useDispatch } from 'react-redux'

const SidePanel = ({ classification }) => {
  const dispatch = useDispatch()

  const featureList = hasClassificationFeatures(classification)
    ? getClassificationFeatures(classification)
    : getRandomFeatures(2)

  if (!featureList || featureList.length === 0) {
    return null
  }

  const handleLearnMore = (feature) => {
    if (feature?.url) {
      window.open(feature.url, '_blank')
    } else {
      dispatch(
        showUpgradeCardModal({
          ...feature.payload,
          onClick: () => onUpgradePlan({ planId: feature?.plan }, dispatch)
        })
      )
    }
  }

  return (
    <Col lg={3} className="d-none d-lg-block" style={{ paddingTop: 90, paddingLeft: 20 }}>
      <div className="side-panel">
        <h2 className="font-16 text-start">Project Tips</h2>
        {featureList.map((feature, index) => (
          <Card key={feature.id || index} className="mb-3">
            <Card.Header className="bg-white border-bottom-0 d-flex align-items-center mb-3">
              <img
                src={feature?.icon}
                alt={feature.title}
                style={{ width: '18px', height: '18px', marginRight: '7px' }}
              />
              <h5 className="mb-0 font-weight-bold">{feature.title}</h5>
            </Card.Header>
            <Card.Body className="text-left pb-3">
              <p className="text-muted mb-0">{feature?.description}</p>
            </Card.Body>
            <Card.Footer className="bg-white border-top-0 text-left">
              <Button
                variant="outline-primary tr-classification-cta"
                size="sm"
                onClick={() => handleLearnMore(feature)}
              >
                Learn more <span>&rarr;</span>
              </Button>
            </Card.Footer>
          </Card>
        ))}
      </div>
    </Col>
  )
}

export default SidePanel
